"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multilineJSX = exports.StyledTooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//Replace new lines with /div, and add non-breaking spaces to tab in text
var multilineJSX = exports.multilineJSX = function multilineJSX(text) {
  var withSpaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!text) return "";
  var lines = text.split(/\r?\n/);
  if (lines.length < 2) return /*#__PURE__*/_react["default"].createElement("span", null, text);
  return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("div", null), withSpaces ? lines.map(function (line, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, "\xA0\xA0\xA0\xA0\xA0", line, /*#__PURE__*/_react["default"].createElement("div", null));
  }) : lines.map(function (line, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, line, /*#__PURE__*/_react["default"].createElement("div", null));
  }));
};

/**
 * Create a StyledTooltip using the theme styles in theme.styledTooltip
 */
var StyledTooltip = exports.StyledTooltip = (0, _styles.withStyles)(function (theme) {
  return {
    tooltip: {
      backgroundColor: theme.styledTooltip.backgroundColor,
      color: theme.styledTooltip.color,
      maxWidth: theme.styledTooltip.maxWidth,
      fontSize: theme.typography.pxToRem(theme.styledTooltip.fontSize),
      border: theme.styledTooltip.border
    }
  };
})(_Tooltip["default"]);